import service from '@/store/services/corridas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  corrida: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, corrida) => {
    state.corrida = corrida;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  actualiza({commit, dispatch}, params) {
    return service.actualiza(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  validate({commit, dispatch}, params) {
    return service.validate(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  listTramosSubcorridas({commit, dispatch}, params) {
    return service.listTramosSubcorridas(params, this.$axios)
      .then((corrida) => { commit('SET_LIST', corrida); });
  },

  listAbordaje({commit, dispatch}, params) {
    return service.listAbordaje(params, this.$axios)
      .then((corrida) => { commit('SET_LIST', corrida); });
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  layoutCorrida({commit, dispatch}, params) {
    return service.layoutCorrida(params, this.$axios)
      .then((corrida) => { commit('SET_LIST', corrida); });
  },

  updateLayout({commit, dispatch}, params) {
    return service.updateLayout(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  getCorridasOrigen({commit, dispatch}, params) {
    return service.getCorridasOrigen(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  getCorridasDestino({commit, dispatch}, params) {
    return service.getCorridasDestino(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },
  
  getInfoCanje({commit, dispatch}, params) {
    return service.getInfoCanje(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  canjearAsiento({commit, dispatch}, params) {
    return service.canjearAsiento(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },
  addSubcorridas({commit, dispatch}, params) {
    return service.addSubcorridas(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },
  getRutasConLimbos({commit, dispatch}, params) {
    return service.getRutasConLimbos(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },
  getGrupoCorridas({commit, dispatch}, params) {
    return service.getGrupoCorridas(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },
  getTotalVentaCorrida({commit, dispatch}, params) {
    return service.getTotalVentaCorrida(params, this.$axios)
      .then((corrida) => { commit('SET_RESOURCE', corrida); });
  },

  destroy({commit, dispatch}, params) {
    if (typeof params === 'object' && params !== null && params.id) {
      return service.destroy(params.id, params.confirm, this.$axios);
    }
    return service.destroy(params, false, this.$axios);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  listTramosSubcorridas: state => state.list,
  listAbordaje: state => state.list,
  layoutCorrida: state => state.list,
  getCorridasOrigen: state => state.corrida,
  getCorridasDestino: state => state.corrida,
  getRutasConLimbos: state => state.corrida,
  getInfoCanje: state => state.corrida,
  getGrupoCorridas: state => state.corrida,
  getTotalVentaCorrida: state => state.corrida,
  canjearAsiento: state => state.corrida,
  addSubcorridas: state => state.corrida,
  updateLayout: state => state.list,
  corrida: state => state.corrida,
  url: state => state.url
};

const corridas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default corridas;
